import React from "react";

const Footer = () => {
  return (
    <>
      <div className="footer-cont d-flex justify-content-center">
        <p className="footer-cont__text">
          Links to web sites are for the convenience of the user. Such links and
          use do not constitute an express or implied endorsement or approval of
          any private sector web site, or of the products or services of
          specifically identified companies or of any of the private entities.
          This information does not reflect an endorsement of these entities,
          and therefore assumes no responsibility for the accuracy of data
          contained herein, or for the success or failure of any business
          transaction resulting from opportunities listed in this information.
        </p>
      </div>

      <footer
        role="contentinfo"
        className="container-fluid p-3 mt-auto"
        style={{ backgroundColor: "#F9F6F2", borderTop: "4px solid #66C594" }}
      >
        <div className="row align-items-center">
          <div className="col-md-2">
            <div className="text-center">
              <img
                alt="COA-Logo-Stacked-Official-RGB.png"
                src="https://austin.widen.net/content/p9gqccm3d8/png/COA-Logo-Stacked-Official-RGB.png?h=100&amp;keep=c&amp;crop=no&amp;color=F9F6F2&amp;quality=80"
              />
            </div>
          </div>
          <div className="col text-right">
            <ul className="list-inline mb-0">
              <li className="list-inline-item">
                <a
                  className="text-dark text-decoration-none"
                  href="//www.austintexas.gov/legal-notice"
                  target="_blank"
                >
                  Legal Notices
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  className="text-dark text-decoration-none"
                  href="//www.austintexas.gov/privacy-notice"
                  target="_blank"
                >
                  Privacy Notice
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;